import type { MainBootHandle } from '../../main';
import {
  buildVibejamPortalUrl,
  readPreferredPlayerName,
  readPreferredPortalColorHex,
} from '../../portal-entry';

export function mountVibejamPortalButton(_handle: MainBootHandle): () => void {
  if (typeof document === 'undefined' || typeof window === 'undefined') {
    return () => {};
  }

  const button = document.createElement('button');
  button.type = 'button';
  button.textContent = '↗ Vibejam Portal';
  button.setAttribute('aria-label', 'Open Vibejam portal');
  button.style.cssText = [
    'position: fixed',
    'left: 16px',
    'bottom: 16px',
    'z-index: 650',
    'min-width: 140px',
    'height: 40px',
    'padding: 0 14px',
    'border: 1px solid rgba(255,255,255,0.18)',
    'border-radius: 8px',
    'background: rgba(16,20,30,0.92)',
    'box-shadow: 0 6px 18px rgba(0,0,0,0.35)',
    'color: #FFFFFF',
    "font-family: var(--typography-family-body, 'Nunito Sans', 'Arial Rounded MT Bold', sans-serif)",
    'font-size: 14px',
    'font-weight: 800',
    'letter-spacing: 0',
    'cursor: pointer',
    'pointer-events: auto',
  ].join('; ');

  const handlePointerEnter = (): void => {
    button.style.background = 'rgba(32,40,58,0.96)';
  };
  const handlePointerLeave = (): void => {
    button.style.background = 'rgba(16,20,30,0.92)';
  };
  const handleClick = (): void => {
    window.location.assign(
      buildVibejamPortalUrl({
        username: readPreferredPlayerName(),
        colorHex: readPreferredPortalColorHex(),
        refHost: window.location.host,
      }),
    );
  };

  button.addEventListener('pointerenter', handlePointerEnter);
  button.addEventListener('pointerleave', handlePointerLeave);
  button.addEventListener('click', handleClick);
  document.body.appendChild(button);

  return () => {
    button.removeEventListener('pointerenter', handlePointerEnter);
    button.removeEventListener('pointerleave', handlePointerLeave);
    button.removeEventListener('click', handleClick);
    button.remove();
  };
}
